import { combineReducers } from 'redux';
import { REDUX } from 'constants/index';
import { Quote } from 'types/quote.type';
import { getReducer } from '../lib/reducerCreator';

const reducers = getReducer(REDUX.QUOTES, [] as Quote[]);

export default combineReducers({ ...reducers });
